import { render, staticRenderFns } from "./ViewMedicationForm.vue?vue&type=template&id=5278aa59&scoped=true"
import script from "./ViewMedicationForm.vue?vue&type=script&lang=js"
export * from "./ViewMedicationForm.vue?vue&type=script&lang=js"
import style0 from "./ViewMedicationForm.vue?vue&type=style&index=0&id=5278aa59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278aa59",
  null
  
)

export default component.exports